var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash-table-cell-wrapper',{attrs:{"placeholder":_vm.contextualPlaceholder,"highlighted":_vm.field.isHighlighted() && !_vm.isInherited,"inherited":_vm.isInherited,"indicator":_vm.indicator}},[(_vm.datetime)?_c('span',{staticClass:"datetime"},[_vm._v(" "+_vm._s(_vm.datetime)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }